import React from 'react';
import { Bot } from 'lucide-react';

const EmptyCoachState = () => (
  <div className="rounded-lg border border-white/10 bg-white/5 p-4 text-center text-purple-100 backdrop-blur-lg">
    <div className="mx-auto mb-3 flex h-10 w-10 items-center justify-center rounded-full bg-fuchsia-500/20 text-fuchsia-100 shadow-[0_0_24px_rgba(217,70,239,0.45)]">
      <Bot size={20} aria-hidden="true" />
    </div>
    <p className="text-sm font-semibold text-white">AIVIONLearn AI Career Coach</p>
    <p className="mt-1 text-xs text-purple-100/80">Ask about your role, weak skills, readiness, CV, or interviews.</p>
  </div>
);

export default EmptyCoachState;
